import { showConfirm } from "infra/helpers/alerta";
import useProcuracoes from "core/features/assembleia/hooks/procuracao/useProcuracoes";
import {
  ProcuracaoItem,
  StatusProcuracaoEnum,
} from "core/features/assembleia/typings/procuracao";
import useFiltro from "infra/helpers/useFiltro";
import { useState } from "react";
import NewTable from "ui/components/NewTable";
import useListagemProcuracoesColumns from "./hooks/useListagemProcuracoesColumns";
import history from "infra/helpers/history";
import HeaderTable from "./components/HeaderTable";
import useAnalisarProcuracao from "core/features/assembleia/hooks/procuracao/useAnalisarProcuracao";

function ListaProcuracoes({ idAssembleia }: { idAssembleia: string }) {
  const [selectedStatus, setSelectedStatus] = useState<
    StatusProcuracaoEnum | undefined
  >();
  const { filtro, onChangeFiltro } = useFiltro();
  const { data, isLoading, isFetching } = useProcuracoes({
    idAssembleia,
    limit: filtro.limit,
    page: filtro.page,
    search: filtro.search,
    status: selectedStatus,
  });

  const { mutate: analisarProcuracao } = useAnalisarProcuracao();

  const columns = useListagemProcuracoesColumns();

  const onClickProcuracao = async (procuracao: ProcuracaoItem) => {
    if (procuracao.status.id === StatusProcuracaoEnum.Pendente) {
      showConfirm(
        "Ao acessar essa procuração você será designado como analista da mesma. Deseja continuar?"
      ).then(({ isConfirmed }) => {
        if (isConfirmed) {
          analisarProcuracao(
            {
              idVotacao: idAssembleia,
              idProcuracao: procuracao.id,
            },
            {
              onSuccess: () => {
                history.push(
                  `/administracao/assembleias/${idAssembleia}/procuracoes/${procuracao.id}`
                );
              },
            }
          );
        }
      });
    } else {
      history.push(
        `/administracao/assembleias/${idAssembleia}/procuracoes/${procuracao.id}`
      );
    }
  };

  return (
    <NewTable<ProcuracaoItem>
      title={() => (
        <HeaderTable
          value={filtro.search || ""}
          onSearch={(v) => onChangeFiltro("search", v)}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
        />
      )}
      loading={isLoading || isFetching}
      columns={columns}
      dataSource={data?.items ?? []}
      customPagination={{
        currentPage: data?.meta.currentPage ?? 0,
        itemsPerPage: data?.meta.itemsPerPage ?? 0,
        totalItems: data?.meta.totalItems ?? 0,
        onChangePage: (p) => onChangeFiltro("page", p),
      }}
      onRow={(record: ProcuracaoItem) => ({
        onClick: () => onClickProcuracao(record),
        style: { cursor: "pointer" },
      })}
    />
  );
}

export default ListaProcuracoes;
